module.exports = __webpack_public_path__ + "static/img/MB-star_M_n_3Coffice.6014dd10.png";